import { PageHeader } from '@ksyos/design-system';
import { useParams, useSearchParams } from '@ksyos/router';
import { useState } from 'react';
import type { IEpisodeCategory } from '@common/interfaces/episodeCategory';
import { ManagerAuthorization } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils';
import { EpisodeCategoryButtonRow } from '../../../elements/EpisodeCategoryButtonRow';
import { OrganizationServiceEmailNotificationSettingsEpisode } from './OrganizationServiceEmailNotificationSettingsEpisode';

export function OrganizationServiceEmailNotificationSettings() {
    const translate = getSelectedLanguage();
    const [searchParams] = useSearchParams();

    const { organizationId } = useParams() as { organizationId: string };
    const selectedCategoryId = searchParams.getOptional('selectedCategoryId');
    const [selectedCategory, setSelectedCategory] = useState<IEpisodeCategory>();
    const [serviceGroupToEdit, setServiceGroupToEdit] = useState<string | undefined>(
        searchParams.getOptional('serviceGroupToEdit')
    );

    assertHasAuthorization(ManagerAuthorization.organizationRead);

    function handleCategoryClick(category: IEpisodeCategory) {
        setSelectedCategory(category);

        if (category.id !== selectedCategoryId) {
            setServiceGroupToEdit(undefined);
        }
    }

    return (
        <>
            <PageHeader title={translate.personalSettings.emailNotifications} />

            <EpisodeCategoryButtonRow
                onCategoryClick={handleCategoryClick}
                organizationId={organizationId}
                selectedCategoryId={selectedCategoryId}
            />

            {selectedCategory && (
                <OrganizationServiceEmailNotificationSettingsEpisode
                    episodeCategory={selectedCategory.name}
                    organizationId={organizationId}
                    serviceGroupToEdit={serviceGroupToEdit}
                />
            )}
        </>
    );
}
